import React, { useRef } from "react";
import circle_empty from '../../img/circle_empty.png'
import circle_full from '../../img/circle_full.png'

export default (p) => {
    const {devis,changeParams,showValidate,focusError} = p.container
    const noCheck = p.noCheck
    const value = devis.params[p.field]
    const label = p.label || devis.getLabel( p.field )
    let message = devis.validateMessage(p.field)
    const ref = useRef()
    if ( message && !noCheck ) focusError(ref)
    if ( !showValidate ) message = undefined

    return <><h3>{label}</h3><div ref={ref} className={'front_form_row'+(message?' invalidbox':'')}>
        <button className={(value=='O')?'yesno selected':'yesno'} onClick={()=>changeParams({[p.field]:'O'})}>
            <img src={(value=='O')?circle_full:circle_empty}/>
            Oui
        </button>
        <button className={(value=='N')?'yesno selected':'yesno'} onClick={()=>changeParams({[p.field]:'N'})}>
        <img src={(value=='N')?circle_full:circle_empty}/>
            Non
        </button>
    </div>
    {message?<div className="invalid">{message}</div>:''}
    </>
}
